import AcompanhamentoGrafico from "@pages/AcompanhamentoGrafico/AcompanhamentoGrafico";

export default AcompanhamentoGrafico;
